import { Typography } from '@mui/material';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { endMessageClass } from '../../constants';
var endMessageSx = {
    padding: function (theme) { return "".concat(theme.spacing(6), " 0"); },
};
export var EndMessage = memo(function (props) {
    var hasNotifications = props.hasNotifications;
    return (React.createElement(Typography, { align: "center", variant: "body2", sx: endMessageSx, className: endMessageClass },
        React.createElement(FormattedMessage, { id: hasNotifications
                ? 'notification.endMessageWithNotifications'
                : 'notification.endMessageWithoutNotifications', defaultMessage: hasNotifications ? 'Более ранних уведомлений нет' : 'Уведомлений пока что нет' })));
});
